import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Flag03 = function Flag03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 13h15.587c.4625 0 .6938 0 .8258-.097a.5.5 0 0 0 .2019-.3566c.0153-.1631-.1037-.3614-.3417-.758l-2.026-3.3768c-.0898-.1496-.1347-.2245-.1523-.3044a.5.5 0 0 1 0-.2144c.0176-.08.0625-.1547.1523-.3044l2.026-3.3768c.238-.3966.357-.5949.3417-.758a.5.5 0 0 0-.2019-.3566C20.2808 3 20.0495 3 19.587 3H4v18"
    })
  }));
};
export default Flag03;